import type { QueryKey } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSettings } from '@wu/widget-core';
import type { Vote, VotesData } from '../../types';
import { voteLocal } from '../local-data';
import type { VoteResponse } from './vote.query';
import { voteQuery } from './vote.query';

export function useVoteMutation(queryKey: QueryKey) {
  const { widgetToken, answers } = useSettings();
  const queryClient = useQueryClient();

  return useMutation<
    VoteResponse['payload'],
    string,
    Vote['id'],
    { previousVotes?: VotesData }
  >({
    mutationFn: async (id) => await voteQuery(id, widgetToken),
    onMutate: async (id) => {
      await queryClient.cancelQueries({
        queryKey
      });

      const previousVotes = queryClient.getQueryData<VotesData>(queryKey);

      if (previousVotes) {
        const newVotes = voteLocal({
          id,
          answers,
          data: previousVotes
        });

        queryClient.setQueryData(queryKey, newVotes);
      }

      return { previousVotes };
    },
    onError: (_, __, context) => {
      if (context && context.previousVotes) {
        queryClient.setQueryData(queryKey, context.previousVotes);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey });
    }
  });
}
